import { registerLocaleData } from '@angular/common'
import localePtExtra from '@angular/common/locales/extra/pt'
import localePt from '@angular/common/locales/pt'
import { LOCALE_ID, enableProdMode } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'
import { AppModule } from './app/app.module'
import { environment } from './environments/environment'
import { menuUtils } from './app/menu/menu.utils'

if (environment.production) {
    enableProdMode()
}

registerLocaleData(localePt, 'pt', localePtExtra)

platformBrowserDynamic([{ provide: LOCALE_ID, useValue: 'pt' }])
    .bootstrapModule(AppModule)
    .catch((err) => console.log(err))

menuUtils.adicionarMenuScript()
menuUtils.adicionarNavbarScript()


// WEBPACK FOOTER //
// ./src/main.ts